import { memo } from 'react';
import { Divider, Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { AccordionResidencyPermit as AccordionResidencyPermitVM } from 'shell/components/shared/sipo-person-form/new-person';

interface IdentityCardProps {
  values?: AccordionResidencyPermitVM;
  onChange: (
    key: keyof AccordionResidencyPermitVM,
    value: AccordionResidencyPermitVM[keyof AccordionResidencyPermitVM]
  ) => void;
}

const MunicipalityReleaseComponent = ({
  values,
  onChange,
}: IdentityCardProps): React.ReactElement => {
  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Questura rilascio</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={7}>
        <MunicipalityList
          label="Comune"
          aria-label="Comune"
          value={values?.municipality || null}
          onChange={(value) => {
            onChange('municipality', value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Provincia"
          id="province"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          onChange={(event) => {
            onChange('province', event?.target.value);
          }}
          value={values?.municipality?.province || ''}
          disabled
        />
      </Grid>
    </Grid>
  );
};

MunicipalityReleaseComponent.displayName = 'Municipality Release component';

const ConsulateRelease = memo(MunicipalityReleaseComponent);

export default ConsulateRelease;
